export const SIGN_IN = "/signin";
export const HOME = "/";
export const ACCOUNT = "/account";
export const APPLOGS = "/app-logs";
export const ENDPOINTS = "/end-points";
export const VERSION_SEARCH = "/version-search";
export const VERSION_GRID = "/version-grid";
export const APPINSTANCES = "/apps";
